import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { headers, GET_TAXINVOICE_LIST_ACTION, taxInvoiceRpt, fetchAuthReport, GET_INVOICE_RPT_ACTION_TYPE, getBenefitListUrl, GET_BENEFIT_LIST_ACTION } from "../../utils/constants"

export const get_benefitList_action = () => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') != '' && sessionStorage.getItem('UserIDSS') != null ? sessionStorage.getItem('UserIDSS') : null,

        }
        const res = await axiosGet(getBenefitListUrl, mapdata, headers);

        dispatch({
            type: GET_BENEFIT_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
